/**
 * Mortar Blocks Frontend JavaScript
 * Handles accordion and tabs interactivity
 */

jQuery(document).ready(function($) {

    // ========================================
    // ACCORDION FUNCTIONALITY
    // ========================================

    $('.mortar-accordion__wrap').each(function() {
        const $accordion = $(this);
        const $panes = $accordion.find('.mortar-accordion');

        // Get the active pane from the wrapper class (e.g., mortar-accordion__active--2)
        const wrapperClasses = $accordion.attr('class');
        const activeMatch = wrapperClasses.match(/mortar-accordion__active--(\d+)/);
        const activePaneNumber = activeMatch ? parseInt(activeMatch[1]) : 1;

        // Open the initially active pane
        $panes.eq(activePaneNumber - 1).addClass('is-open');

        // Click handler for accordion titles
        $accordion.on('click', '.mortar-accordion__title a', function(e) {
            e.preventDefault();
            const $pane = $(this).closest('.mortar-accordion');
            const $thisAccordion = $pane.closest('.mortar-accordion__wrap');

            // Toggle the clicked pane
            $pane.toggleClass('is-open');

            // Close other panes (if link pane collapse is enabled, only one pane can be open)
            // For now, we'll allow multiple panes to be open
            // To enable single-pane mode, uncomment the following:
            // $thisAccordion.find('.mortar-accordion').not($pane).removeClass('is-open');
        });
    });

    // ========================================
    // TABS FUNCTIONALITY
    // ========================================

    $('.mortar-tabs').each(function() {
        const $tabs = $(this);
        const $tabList = $tabs.find('.mortar-tabs__list');
        const $tabItems = $tabList.find('.mortar-tabs__item');
        const $tabPanels = $tabs.find('.mortar-tabs__parts > *');

        // Get initially active tab from class (e.g., kt-active-tab-1)
        const tabClasses = $tabs.attr('class');
        const activeMatch = tabClasses.match(/kt-active-tab-(\d+)/);
        const activeTabNumber = activeMatch ? parseInt(activeMatch[1]) : 1;

        // Set initial active states
        $tabItems.eq(activeTabNumber - 1).addClass('selected');
        $tabPanels.eq(activeTabNumber - 1).addClass('is-active');

        // Click handler for tab anchors
        $tabs.on('click', '.mortar-tabs__anchor', function(e) {
            e.preventDefault();
            const $anchor = $(this);
            const $item = $anchor.closest('.mortar-tabs__item');
            const tabNumber = $anchor.data('tab');
            const $thisTabs = $item.closest('.mortar-tabs');

            // Update active classes on tab items
            $thisTabs.find('.mortar-tabs__item').removeClass('selected');
            $item.addClass('selected');

            // Update active classes on tab panels
            $thisTabs.find('.mortar-tabs__parts > *').removeClass('is-active');
            $thisTabs.find('.mortar-tabs__parts > *').eq(tabNumber - 1).addClass('is-active');

            // Update the wrapper class for state tracking
            $thisTabs.attr('class', function(i, className) {
                return className.replace(/kt-active-tab-\d+/, 'kt-active-tab-' + tabNumber);
            });
        });
    });

    // ========================================
    // ACCESSIBILITY IMPROVEMENTS
    // ========================================

    // Keyboard navigation for accordions
    $('.mortar-accordion__title a').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });

    // Keyboard navigation for tabs
    $('.mortar-tabs__anchor').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }

        // Arrow key navigation between tabs
        const $anchor = $(this);
        const $item = $anchor.closest('.mortar-tabs__item');
        const $tabList = $item.closest('.mortar-tabs__list');
        const $allItems = $tabList.find('.mortar-tabs__item');
        const currentIndex = $allItems.index($item);

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % $allItems.length;
            $allItems.eq(nextIndex).find('.mortar-tabs__anchor').focus().trigger('click');
        }

        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = (currentIndex - 1 + $allItems.length) % $allItems.length;
            $allItems.eq(prevIndex).find('.mortar-tabs__anchor').focus().trigger('click');
        }
    });
});
